import React, {Component} from 'react';
import Basic_BTN from '../../../assets/images/basic_btn.png';
import Gold_BTN from '../../../assets/images/gold_btn.png';
import Basic_BTN_SOMALI from '../../../assets/images/basic_btn_somali.png';
import Gold_BTN_SOMALI from '../../../assets/images/gold_btn_somali.png';
import {changelanguage} from "../../../helpers/changelanguage";
import { changeLanguage } from "../../../actions/languagechangeAction";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";


class Form extends Component {
  constructor(props){
    super(props);
    this.state = {
      language_list : {}
    };
    this.changelanguage = this.changelanguage.bind(this);
  }

  componentDidMount() {
    this.changelanguage(localStorage.getItem('userLanguage') == undefined ? 'so' : localStorage.getItem('userLanguage'));
  }
  changelanguage(lang){
    changelanguage(lang);
    this.props.changeLanguage(lang);
  }
  UNSAFE_componentWillReceiveProps(nextProps){ 
   
    if((this.props.currentlanguagelist != nextProps.currentlanguagelist) && (nextProps.currentlanguagelist !== undefined) && (this.props.currentlanguagelist  !== undefined)){
      console.log(420);
       window.location.reload();
    }
  }
  render() {
    
    let language     = this.props.currentlanguage;
    let languagelist = this.props.currentlanguagelist || {};
                     
    return (
        <div className="reg_box">
          <h2>{`${languagelist.donothaveanaccount}? `}
          <a href={void(0)}>{languagelist.registernow}</a>
        </h2>
        <div className="text-center">
          <a href="/registration/basic"><img className="rs_img" src={language== 'en' ? Basic_BTN : Basic_BTN_SOMALI}/></a>
          <div className="clr20"></div>
          <a href="/registration/gold"><img className="rs_img" src={language== 'en' ? Gold_BTN : Gold_BTN_SOMALI}/></a>
        </div>
          <p className="text-center loginsuggestion mb-150"> {languagelist.membershipcontent}</p>
          <ul className="bottom_border">
              <li></li>
              <li></li>
          </ul>

          <div className="text-center loginsuggestion" >
              <a href={void(0)} 
                 onClick={()=>this.changelanguage('so')} 
                 style={{cursor : "pointer"}}
                 className={language == 'so' ? "selected-language" : ""}
              >
                   Somali</a> &nbsp; / &nbsp;
              <a 
              href={void(0)} 
              onClick={()=>this.changelanguage('en')} 
              style={{cursor : "pointer"}}
              className={language == 'en' ? "selected-language" : ""}
              >English</a>
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentlanguage     : state.currentlanguage.currentlanguage.language,
    currentlanguagelist : state.currentlanguage.currentlanguage.languagelist,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeLanguage : bindActionCreators(changeLanguage , dispatch),
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Form));
